<script>
  import FilePond, { registerPlugin, supported } from "svelte-filepond"

  import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation"
  import FilePondPluginImagePreview from "filepond-plugin-image-preview"

  export let server

  registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview)

  let pond

  let name = "images"

  // Send the Rails CSRF token so the upload endpoints can keep
  // verify_authenticity_token enabled instead of skipping it.
  const csrfToken =
    document.querySelector('meta[name="csrf-token"]')?.content || ""

  const serverConfig = {
    url: server,
    process: {
      headers: { "X-CSRF-Token": csrfToken },
      onerror: (response) => response
    }
  }

  const processingErrorLabel = (error) =>
    (error && error.body) || "Error during upload"
</script>

<main>
  <div class="app">
    <FilePond
      bind:this={pond}
      {name}
      server={serverConfig}
      allowMultiple={true}
      credits={null}
      labelIdle="Upload pictures"
      labelFileProcessingError={processingErrorLabel}
    />
  </div>
</main>

<style>
  @import "filepond/dist/filepond.css";
  @import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
</style>
